







































import {Component, Vue, Inject, Prop, Watch} from 'vue-property-decorator';
import AbpBase from '../../lib/abpbase'
import basicInfo from './basicInfo.vue'
import diagnoseInfo from './diagnoseInfo.vue'
import pathway from './pathway.vue'
import dialysisInfo from './dialysisInfo.vue'
import testInfo from './testInfo.vue'
import dialysisRecipe from './dialysisRecipe.vue'
import sufficiency from './sufficiency.vue'
import dakwahInfo from './dakwahInfo.vue'
import imageInfo from './imageInfo.vue'
import lapseTo from './lapseTo.vue'
import pharmacyInfo from './pharmacyInfo.vue'
@Component({
    components: {basicInfo,diagnoseInfo,pathway,dialysisInfo,testInfo,dialysisRecipe,sufficiency,dakwahInfo,imageInfo,lapseTo,pharmacyInfo}
})
export default class extends AbpBase {
    @Prop({type:Number,default:null}) id:any;
    @Prop({type:String,default:'基本信息'}) activeName:any;
    activeNames = '基本信息'
    created(){
        this.activeNames = this.activeName
    }
    handleClick(){
        this.$emit('tabsChange',this.activeNames);
        this.$nextTick(()=>{
            if((this.$refs.testInfo as any)){
                (this.$refs.testInfo as any).searchPopShow = false;
            }
            if((this.$refs.dakwahInfo as any)){
                (this.$refs.dakwahInfo as any).searchPopShow = false;
            }
        })
        
    }
}
